<template>
  <div ref="switch" class="c-switch" :class="placement" :style="componentStyle" @click="$emit('on-select')">
    <div class="c-switch-wrap" :class="{ 'c-active-check': active }" :style="componentColor">
      <img v-if="bgImage" :src="bgImage" width="100%" />
      <div v-if="!!image || !!bgImage" class="c-complete" :class="completeClass">
        <img v-if="btnstyle === 'block'" :src="image" width="100%" height="100%" alt="" />
        <img v-else :src="image" alt="" />
      </div>
      <div v-else class="c-init" :class="initClass">
        <template v-if="btnstyle === 'block'">
          <Icon :type="icon" size="24" />
          <span class="flex-col">请添加按钮图片</span>
        </template>
        <span v-else class="flex-row">按钮图片</span>
      </div>
      <div v-show="active" class="c-corn">
        <Button shape="circle" icon="md-trash" @click.stop="$emit('on-delete')" />
      </div>
    </div>
  </div>
</template>
<script>
import { div } from '@/common/js/api'
import { preLoadImg } from '@/common/js/utils'
export default {
  name: 'switchComponent',
  props: {
    attr: {
      type: Array,
      default() {
        return []
      }
    },
    active: {
      type: Boolean,
      default() {
        return false
      }
    },
    icon: {
      type: String
    },
    pos: {
      type: Object
    }
  },
  computed: {
    image() {
      let url = ''
      const index = this.attr.findIndex((ret) => ret.name === 'image')
      if (index > -1) url = this.attr[index].image
      return url
    },
    bgImage() {
      let url = ''
      const index = this.attr.findIndex((ret) => ret.name === 'btn_bg_image')
      if (index > -1) url = this.attr[index].btn_bg_image
      return url
    },
    btnstyle() {
      let style = 'block'
      const index = this.attr.findIndex((ret) => ret.name === 'btnstyle')
      if (index > -1) style = this.attr[index].btnstyle
      return style
    },
    justifyContent() {
      let align = 'center'
      const index = this.attr.findIndex((ret) => ret.name === 'align')
      if (index > -1) align = this.attr[index].align
      return align
    },
    placement() {
      let p
      const index = this.attr.findIndex((ret) => ret.name === 'position')
      if (index > -1) p = this.attr[index].position
      return `c-switch-${p}`
    },
    color() {
      let colors = '#fff'
      const index = this.attr.findIndex((ret) => ret.name === 'color')
      if (index > -1) colors = this.attr[index].color
      return colors
    },
    componentStyle() {
      const { top, bottom } = this.pos
      const elBottom = bottom - this.imageHeight - 4
      if (this.placement.includes('top')) {
        return { top: `${top}px` }
      } else if (this.placement.includes('bottom')) {
        return { top: `${elBottom}px` }
      } else return {}
    },
    componentColor() {
      return { backgroundColor: this.color }
    },
    controlStyle() {
      const visiable = this.active ? 'visible' : 'hidden'
      return {
        visibility: visiable
      }
    },
    completeClass() {
      return {
        'c-complete-padding': this.btnstyle !== 'block',
        'c-complete-end': this.justifyContent !== 'center',
        'c-complete__bgimage': this.bgImage
      }
    },
    initClass() {
      return {
        'c-init-col': this.btnstyle === 'block',
        'c-init-end': this.justifyContent !== 'center'
      }
    }
  },
  watch: {
    image() {
      this.uploadDom()
    }
  },
  data() {
    return {
      imageHeight: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.uploadDom()
    })
  },
  methods: {
    async uploadDom() {
      if (this.image) {
        const { width, height } = await preLoadImg(this.image)
        if (this.btnstyle === 'block') this.imageHeight = (height * 375) / width
        else this.imageHeight = div(height, 2)
      } else this.imageHeight = 80
    }
  }
}
</script>
<style lang="scss" scoped>
.c-switch {
  width: 100%;
  // height 81px
  position: relative;
  z-index: 3;

  &.c-switch-bottom {
    position: absolute;
    bottom: 0;
  }

  &.c-switch-top {
    position: absolute;
  }

  .c-switch-wrap {
    width: 375px;
    // height 80px
    margin: 0 auto;
    box-shadow: 1px 1px 7px 1px #e8e8e8;
    position: relative;

    &.c-active-check {
      border: solid 2px #4b77ee;

      // &:before
      // content ''
      // position absolute
      // z-index -1
      // width 100%
      // height inherit
      // background-color #e8e9eb
      // left 0
      i,
      span {
        color: #4b77ee;
      }
    }

    .c-complete {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &.c-complete-padding {
        min-height: 60px;
        padding: 0 16px;

        img {
          max-width: 750px;
          zoom: 0.5;
        }
      }

      &.c-complete-end {
        justify-content: flex-end;
      }

      &.c-complete__bgimage {
        position: absolute;
        top: 0;
      }
    }

    .c-init {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 80px;
      padding: 0 16px;

      &.c-init-col {
        flex-direction: column;
      }

      // background-color #fff
      &.c-init-end {
        justify-content: flex-end;
      }

      span.flex-col {
        font-size: 14px;
        line-height: 22px;
        margin-top: 4px;
      }

      span.flex-row {
        font-size: 14px;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        background-color: #e0e0e0;
        color: #3a3a3a;
        text-align: center;
      }
    }

    .c-corn {
      width: 32px;
      height: 40px;
      position: absolute;
      z-index: 4;
      top: 20px;
      right: -52px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}
</style>
